export default defineNuxtPlugin(async () => {
  const route = useRoute()
  const router = useRouter()
  const store = useCustomerStore()

  const token = route.query.login as string | undefined
  if (!token) return

  if (store.isLoggedIn) {
    await cleanUrl()
    return
  }

  try {
    await store.loginWithToken(token)
  } catch (err) {
    console.warn('[auth] token-login: failed', err)
  }

  await cleanUrl()

  async function cleanUrl() {
    const { login, nlhash, ...rest } = route.query
    await router.replace({ path: route.path, query: rest, hash: route.hash })
  }
})
